import clsx from 'clsx';
import Link from 'next/link';
import date from '@/utils/date';
import ClientOnly from '@/components/ClientOnly';
import styles from './styles.module.scss';
import parentStyles from '../styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleAuthors = _ref => {
  let {
    className,
    authors = [],
    reviewers = [],
    updatedAt
  } = _ref;
  const hasAuthors = authors.length > 0;

  if (!hasAuthors) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx("ul", {
    className: clsx(parentStyles.article__authors, styles.list, className || ''),
    children: authors.map((author, index) => {
      const slug = getAuthorUrl(author.slug);
      const title = getAuthorLinkTitle(author.fullName);
      const isLast = authors.length - 1 === index;
      return /*#__PURE__*/_jsxs("li", {
        className: styles.item,
        children: [/*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: slug,
          children: /*#__PURE__*/_jsx("a", {
            title: title,
            className: styles.item__image,
            children: Boolean(author.avatarUrl) && /*#__PURE__*/_jsx("img", {
              src: author === null || author === void 0 ? void 0 : author.avatarUrl,
              loading: "lazy",
              alt: `Author ${author.fullName} avatar`
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.item__content,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.heading,
            children: ["Written by", ' ', /*#__PURE__*/_jsx(Link, {
              legacyBehavior: true,
              href: slug,
              title: title,
              children: /*#__PURE__*/_jsx("a", {
                children: author.fullName
              })
            })]
          }), isLast && reviewers.length ? /*#__PURE__*/_jsxs("span", {
            className: clsx(styles.heading, styles['heading--muted']),
            children: ["Reviewed by", ' ', reviewers.map((reviewer, revIndex) => {
              return /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: getAuthorUrl(reviewer.slug),
                children: /*#__PURE__*/_jsx("a", {
                  title: getAuthorLinkTitle(reviewer.fullName),
                  children: reviewer.fullName
                })
              }, `reviewer-${revIndex}-${encodeURIComponent(reviewer.slug)}`);
            })]
          }) : /*#__PURE__*/_jsx(_Fragment, {}), updatedAt && /*#__PURE__*/_jsx(ClientOnly, {
            children: /*#__PURE__*/_jsx("time", {
              dateTime: date.toDateString(updatedAt),
              className: styles.timestamp,
              children: date.toFullTextDate(updatedAt)
            })
          })]
        })]
      }, `author-${index}-${encodeURIComponent(author.slug)}`);
    })
  });
};

export default ArticleAuthors;

function getAuthorUrl(slug) {
  return `/authors/${slug}`.replace(/\/\//g, '/');
}

function getAuthorLinkTitle(fullName) {
  return `${fullName}'s author profile`;
}